// extracted by mini-css-extract-plugin
module.exports = {"profile":"ProfileAvatar_profile__YRSU0","avatar":"ProfileAvatar_avatar__0bwXQ","username":"ProfileAvatar_username__XKzz1"};